  <div class="row mb-4">
      <div class="col-6">
        <button type="button" class="btn btn-primary" (click)="goBack()">Back</button>
      </div>
  </div>
  <div class="container text-center mt-3 mb-3 border">
     <form #f="ngForm" [formGroup]="productForm">
      @if(!doneAddingAttendees){
      <div class="row mb-4">
      <div class="col-12">
      <mat-form-field style="width: 300px;">
        <mat-label>Name</mat-label>
        <input matInput (input)="onInputChange($event)" formControlName="name">
        <mat-hint>Invitee Name</mat-hint>
      </mat-form-field>
      </div>
      </div>
      <div class="row mb-4">
      <div class="col-12">
      <mat-form-field style="width: 300px;">
        <mat-label>Email:</mat-label>
        <input matInput (input)="onInputChange($event)" formControlName="email" type="email" class="form-control">
        <mat-hint> Invitee Email Address</mat-hint>
        <mat-error>Please enter a valid email.</mat-error>
      </mat-form-field> 
      </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <mat-form-field  style="width: 300px;">
              <mat-label>Phone Number:</mat-label>
              +1<input matInput (input)="onInputChange($event)" formControlName="phone" type="tel" mask="(000) 000-0000" class="form-control">
              <mat-hint>(111) 123-4567</mat-hint>
              <mat-error>Please enter a valid phone.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-2 me-5">
              <button type="button" (click)="onCancel()" class="btn btn-secondary">Cancel</button>
        </div>
        @if(editMode || showVerifyBtn){
          <div class="col-2 me-5">
              <button type="button" (click)="onVerify()" class="btn btn-primary">Verify</button>
          </div>
        }
     
        @if(!showVerifyBtn && !editMode){
          <div class="col ms-5">
              <button type="button" (click)="done()" class="btn btn-primary">Done Adding Attendees</button>
          </div>
        }
        
      </div>
    }
    </form>  
  <div>
   
</div>

<form #f="ngForm" [formGroup]="invitedForm">
   @if(!doneAddingAttendees){
    <div class="row text-center">
      <div class="col"> Invited Attendees </div>
    </div>
   }
 
   <div class="row text-center">
      <table mat-table [dataSource]="dataSource" >
      <!-- Define your table columns here -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="row text-center" mat-cell *matCellDef="let element;  let k = index">
          <div>
            {{element.name}}
            <button mat-icon-button (click)="edit(element, k)" aria-label="edit icon">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div>
            {{element.phone}}
          </div>
          <div>
            {{element.email}}
          </div>
        </td>
      </ng-container>
      
      @if(attendeeListUpdated){
        <ng-container matColumnDef="isnewlyadded">
          <th mat-header-cell *matHeaderCellDef> Newly Added/Updated </th>
          <td mat-cell *matCellDef="let element"> 
            @if(element.isnewlyadded){
              <mat-checkbox checked disabled></mat-checkbox>
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</form>

<form [formGroup]="messageForm">
     
      <div class="row">
        <div class="col">
            <mat-radio-group formControlName="messageAudience">
              <mat-radio-button [checked]="true" color="primary" value="messageAll">
                      All
              </mat-radio-button>
              <mat-radio-button color="primary" value="messageNewlyAdded">
                      Newly added/updated invitees only
              </mat-radio-button>
            </mat-radio-group>
      </div>
     </div>
      <div class="row">
      <mat-form-field class="full-width-field">
      <mat-label>Send Invitation</mat-label>
      <textarea matInput
        formControlName="sendAllReminder"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10">
      </textarea>
      @if(messageForm.get('sendAllReminder')?.invalid && messageForm.get('sendAllReminder')?.touched){
          Message must be between 5 and 200 characters long.
      }
      </mat-form-field>
      </div>
      @if(doneAddingAttendees){
        <div class="row">
          <button type="button" (click)="onSubmit()" class="btn btn-success">Submit</button>
        </div>
      }
</form>
</div> 
<ng-template #successfullyVerified>
  <div class="container">
  <h2 mat-dialog-title>Success</h2>
  <mat-dialog-content>
    <p>Successfully verified.</p>
    </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ok</button>
  </mat-dialog-actions>
  </div>
</ng-template>
<ng-template #unableToVerify>
  <div class="container">
  <h2 mat-dialog-title>Failed</h2>
  <mat-dialog-content>
    <p>Unable to verify. Either the phone is blocked or not in our database.</p>
    </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ok</button>
  </mat-dialog-actions>
  </div>
</ng-template>
